import { useDispatch, useSelector } from "react-redux";
import useOrganizationColumn from "./Hooks/useOrganizationColumn";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import UserFilter from "../../Settings/UserManagement/Users/UserFilter";
import NewOrganizationModal from "./NewOrganizationModal";
import { checkAccessPermission, checkButtonAccess, getOrgId, getOrganizationId } from "../../../Utils/CommonUtils";
import { getOrganizationListing } from "./OrganizationService";
import { useEffect } from "react";
import { resetFormState } from "../../../slices/common/reducer";
import OrganizationFilter from "./OrganizationFilter";
import {
  setOrganizationData,
  setOrganizationFilterForm,
  setOrganizationSorting,
} from "../../../slices/org/organizationSlice";
import { getFilteredDataWithTabs } from "../../../Utils/CommonService";

const OrganizationListing = () => {
  const dispatch = useDispatch();
  const { organizationColumns } = useOrganizationColumn();
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const modalShow = useSelector((state) => state.common.modalShow);
  const editShow = useSelector((state) => state.common.editShow);
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterApi = useSelector((state) => state.organization.filter.filterApi);
  const filterForm = useSelector((state) => state.organization.filter.form);
  const sortColumn = useSelector((state) => state.organization.sorting.column);
  const sortOrder = useSelector((state) => state.organization.sorting.order);
  const organizationData = useSelector(
    (state) => state.organization.organizationData
  );
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const parentId = selectedUser.organizationid;
  const enterpriseid = localStorage.getItem("enterpriseid");
  const accessData = useSelector((state) => state.common.sidebarData);

  useEffect(() => {
    dispatch(setOrganizationFilterForm({ type: "reset" }))
  }, []);

  return (
    <div>
      <CommonHeader
        newButton={true}
        checkAccessCreate={checkButtonAccess("CREATE", "ORG_ORG")}
        buttonTitle={"New Organization"}
        filterComponent={<OrganizationFilter />}
        dash={true}
      />
      <div>
        {/* <TableWrapper
          columns={organizationColumns}
          data={organizationData}
          // apiTabData={apiTabData}
          // paginatedApi
          // filterApi
          // filterApiEntity={"USR"}
          // filterApiListEntity={"USR"}
          // filterApiFunction={setUsersData}
          // filterApiService={getListingByOrgId}
          // filterForm={filterForm}
          totalRows={totalRows}
          // status={id}
          // statusColumn={"status"}
          // download
          // handleDownload={handleDownload}
          // hideTabs
          // hideTabsWrapper={true}
        /> */}
        <TableWrapper
          columns={organizationColumns}
          data={organizationData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"ORG"}
          filterApiListEntity={"ORG"}
          filterApiFunction={setOrganizationData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setOrganizationSorting}
          parentId2={parentId}
          enterpriseId={enterpriseid}
        />
      </div>
      {(modalShow || editShow) && <NewOrganizationModal />}
    </div>
  );
};

export default OrganizationListing;
